<template>
  <div class="per-container">
    <div class="title-box">
      <label>欢迎使用</label>
      <span
        >为保证您能正常使用机场集团气象预报产品信息展示相关功能请您申请以下权限：</span
      >
    </div>
    <div class="body-box">
      <div class="per-item" v-show="roleList.length>0" v-for="(item,i) in roleList" v-bind:key="i" @click="checkcell(i)">
        <div class="item-left">
          <label class="per-title"
            >{{item.titel}}<span :class="{ed:item.state==='(已申请)',other:item.state!=='(已申请)'}">{{item.state}}</span></label
          >
          <span class="per-content"
            >{{item.content}}</span
          >
        </div>
        <div :class="{'item-right':true,'active':sendIndex===i||perName===item.titel}" v-show="item.state!=='(已申请)'"><span></span></div>
      </div>
    </div>
    <div class="foot-box">
      <div class="public-btn" @click.stop="gosend">
        <span>{{perName||sendIndex===-1?'返回':'立即申请'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "permissions",
  data() {
    return {
      isRegist: false,
      sendIndex:-1,
      perName: '', // 正在申请的权限名称
      roleList:[]
    };
  },
  mounted() {
    // 检查是否需要注册
    const _rgsUserInfo = this.$storage.get("rgsUserInfo");
    const _falg = Object.prototype.toString.call(_rgsUserInfo) === "[object Object]";
    this.isRegist = _falg ? "wxOpenId" in _rgsUserInfo : false;
    // 加载权限
    this.initPer();
  },
  methods: {
    // 注册用户（bos平台）
    toRegist() {
      let that = this;
      this.$http({
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        method: "post",
        url: that.$initUrl.api_url + "/xjjc_user",
        data: JSON.stringify(that.$storage.get("rgsUserInfo"))
      })
        .then(response => {
          console.log("注册成功", response.data);
          //清除用户注册信息缓存
          that.$storage.remove("rgsUserInfo");
          //跳转到主页（我的）界面,进行权限申请
          that.$store.dispatch("setUpmsUser", {
            ele: that,
            data: response.data["data"],
            back: function() {
              that.$notify({ type: "danger", message: "注册成功！" });
              that.toPer()
              //that.$router.push("/");
            }
          });
        })
        .catch(function(e) {
          console.log("注册失败：", e);
        });
    },
    // 申请权限
    gosend(){
      if (this.isRegist) {
        this.toRegist();
        return
      }
      this.toPer()
    },
    toPer() {
      const that = this
      if(this.sendIndex==-1){
        //等待审批
        /*this.$toast({
          message: _flagArr.length>0?'请等待审批结果':'请选择权限',
          forbidClick: false,
          duration: 500
        });*/
        that.$router.push('/Home');
        return;
      }
      let roledic = this.$storage.get('roleDic');
      this.$store.dispatch('sendApply',{ele:this,roleid:roledic[this.sendIndex].id,rolename:roledic[this.sendIndex].role_name,menus:roledic[this.sendIndex].menuitem_role,success:function(){
          that.$router.push('/Home');
        },fail:function(e){
          that.$toast('权限申请失败：'+e);
        }});
    },
    // 加载权限选项
    initPer() {
      // const _perInfo = this.$storage.get('perInfo')
      const that = this
      const _user = this.$storage.get('upmsUser');
      const _role = this.$storage.get('roleDic')
      const _perInfo = this.$storage.get('perInfo')
      //用户当前角色名
      const _rolename = _user?_user.role_name:''
      //当前申请角色名
      const _pername = Object.prototype.toString.call(_perInfo) === "[object Object]" && ('name' in _perInfo)?_perInfo.name:''
      const _roleArr = []
      let _index = 99
      that.perName = _pername
      // 获取各级权限数据
      for (let i in _role){
        if(_rolename.indexOf(_role[i].role_name)>-1){
          _index = i
        }
        console.log('remark', _role[i].remark)
        _roleArr[parseInt(_role[i].role_level)] = {
          titel: _role[parseInt(i)].role_name,
          state:that.getState(_rolename,_pername,_role[i].role_name,_user||_pername),
          content: _role[i].remark // parseInt(i)===0?_role[i].menuitem_role.split(',').join('、'):that.getContent(_role[parseInt((i-1))].menuitem_role.split(','), _role[i].menuitem_role.split(','))
        }
      }
      if(_index !== 99){
        for(let i=_index;i>=0;i--){
          _roleArr[i].state = '(已申请)'
        }
      }
      this.roleList = _roleArr
    },
    // 选择申请项
    checkcell(index){
      if(this.perName){
        return
      }
      const _role = this.$storage.get('roleDic')
      const _perInfo = this.$storage.get('perInfo')
      //当前申请角色名
      const _pername = Object.prototype.toString.call(_perInfo) === "[object Object]" && ('name' in _perInfo)?_perInfo.name:''
      for(let i in _role){
        if(_role[i].role_name === _pername){
          this.sendIndex = i
        }
      }
      this.sendIndex = !_pername?index:this.sendIndex
    },
    // 获取当前角色申请状态
    getState(ed,ing,name,flag){
      let text = '(未申请)'
      if(!flag){
        return text
      }
      if(name === ed ){
        text = '(已申请)'
      }else if(name === ing){
        text = '(等待审核)'
      }
      return text
    },
    // 获取角色列表描述信息
    getContent(first,last){
      return this.$btools.fuc.getArrayItem('d',first,last).join('、')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.per-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .title-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 20%;
    width: 86%;
    label {
      font-size: px2rem(30);
      color: #ffffff;
    }
    span {
      margin-top: px2rem(10);
      line-height: px2rem(16);
      font-size: px2rem(14);
      color: #b7b7b7;
    }
  }
  .body-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 59%;
    width: 95%;
    .per-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: px2rem(116);
      background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
      box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.24),
        inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
      border-radius: 12px;
      margin-bottom: px2rem(14);
      .item-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 80%;
        margin-left: px2rem(17);
        .per-title {
          font-size: px2rem(16);
          color: #d4d4d4;
          .ed {
            margin-left: px2rem(10);
            color: #01b876;
          }
          .other {
            margin-left: px2rem(10);
            color: #e02c00;
          }
        }
        .per-content {
          margin-top: px2rem(8);
          line-height: px2rem(18);
          font-size: px2rem(14);
          color: #a9abad;
        }
      }
      .item-right {
        width: px2rem(18);
        height: px2rem(18);
        border: solid 1px #ffffff;
        margin-right: px2rem(17);
        border-radius: 50px;
      }
      .item-right.active {
        background-color: #e02c00;
        span {
          width: 8px;
          height: 16px;
          border-color: #ffffff;
          border-style: solid;
          border-width: 0 3px 5px 0;
          transform: rotate(45deg);
        }
      }
    }
  }
  .foot-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 21%;
    width: 95%;
  }
}
</style>
